<template>
  <div>
    <NavBar v-if="admin" :admin="true" :items="items" />
		<Breadcrumbs v-else :items="items" />
    <v-main :class="admin ? 'mx-12' : 'pa-0'">
      <v-container>
        <v-row v-if="admin" no-gutters>
          <v-col cols="12" md="4" class="px-2 treatment-card mb-5">
            <v-card :to="admin ? { name: 'admin-acu-points'} : { name: 'acu-points'}" :disabled="!admin">
              <v-card-title>
                <v-icon color="primary" class="mr-2">$vuetify.icons.acuIcon</v-icon>
                <span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'" v-translate>Points</span>
              </v-card-title>
              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="px-2 treatment-card mb-5">
            <v-card :to="{ name: 'admin-acu-groups'}" :disabled="!admin">
              <v-card-title>
                <v-icon color="primary" class="mr-2">$vuetify.icons.acuIcon</v-icon>
                <span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'" v-translate>Groups</span>
              </v-card-title>
              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="2" class="px-2 mb-5">
            <v-card @click="showBodyGraphic = true" disabled>
              <v-card-title>
                <v-icon color="primary" class="mr-2"></v-icon>
                <span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'" v-translate>Body</span>
              </v-card-title>
              <v-card-actions></v-card-actions>
            </v-card>
            <AcupunctureGraphicMode :show="showBodyGraphic" @close="showBodyGraphic = false" :auricular="false" :admin="true" />
          </v-col>
          <v-col cols="12" md="2" class="px-2 mb-5">
            <v-card @click="showAuricularGraphic = true">
              <v-card-title>
                <v-icon color="primary" class="mr-2"></v-icon>
                <span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'" v-translate>Auricular</span>
              </v-card-title>
              <v-card-actions></v-card-actions>
            </v-card>
            <AcupunctureGraphicMode :show="showAuricularGraphic" @close="showAuricularGraphic = false" :auricular="true" :admin="admin" :createMode="true" />
          </v-col>
        </v-row>
        <template v-else>
          <AcupunctureSelector :createMode="true" />
          <v-row no-gutters class="mb-4">
            <v-col cols="12">
              <p v-if="acuPoints.length == 0 && (ashiPoints == null || ashiPoints == '')" class="font-weight-thin ml-2" v-translate>No points.</p>
              <template v-else>
                <template v-if="ashiPoints != null && ashiPoints != ''">
                  <span class="primary--text font-weight-medium" v-translate>Ashi Points</span><span class="font-weight-light ml-2">{{ashiPoints}}</span>
                </template>
                <AcupunctureGrid v-if="acuPoints.length > 0" :acuPoints="acuPoints" @remove-point="removePoint" />
              </template>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import AcupunctureGraphicMode from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureGraphicMode.vue";
import AcupunctureSelector from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureSelector.vue";
import AcupunctureGrid from "@/components/appointment/treatments/tcm/acupuncture/AcupunctureGrid.vue";

export default {
  name: "Acupuncture",
  props: ["admin"],
  components: {
    NavBar,
    Breadcrumbs,
    AcupunctureGraphicMode,
    AcupunctureSelector,
    AcupunctureGrid
  },
  data: () => ({
    showBodyGraphic: false,
    showAuricularGraphic: false
  }),
  computed: {
    items() {
      if(this.admin){
        return [
          {
            text: this.$gettext("Dashboard"),
            disabled: false,
            link: true,
            to: "/admin/dashboard"
          },
          {
            text: this.$gettext("Acupuncture"),
            disabled: true,
            link: true
          }
        ];
      } else {
        return [
					{
						text: this.$gettext("Dashboard"),
						disabled: true,
						link: true,
            to: { name: "home" }
					},
					{
						text: this.$gettext("Treatments"),
						disabled: false,
						link: true,
						to: { name: "treatments" }
					},
					{
						text: this.$gettext("Acupuncture"),
						disabled: true,
						link: true
					}
				];
      }
    },
    acuPoints() {
			return this.$store.getters.acuPoints(false);
		},
		ashiPoints() {
			return this.$store.getters.ashiPoints;
		}
  },
  methods: {
    removePoint(point) {
			let data = {
				appointment: -1,
				op: "remove_point",
				id: point.id
			}
			this.$store.dispatch("REMOVE_POINT", data);
		}
  },
  mounted() {
    this.$store.dispatch("RESET_DATA");
  }
}
</script>